import React from 'react';
import { Navigation } from 'navigations';
function App() {
    return <Navigation />;
}

export default App;
